
import { useEffect, type JSX } from "react";
import { useForm } from "react-hook-form"
import { RoleLevel, roles, type User } from "../../types/Users";
import { FloatinBooleanBootstrap, FloatingInputBootStrap, FloatingPrefixInputBootStrap } from "../Common/FloatingInputBootstrap";
import type { ResponseError } from "../../types/CommonReponse";
import { useUpdateUserMutation } from "../../stores/OkOkStore";
import { Navigate } from "react-router";
import { useAuth } from "../../contexts/auth/useAuth";
import { useTrads } from "../../contexts/trads/useTrads";
import PasswordSetter from "../Common/PasswordSetter";

interface Props  {
    userParam: Partial<User> & Pick<User,'id'>;
   
};


export function  UserEditForm ({userParam}: Props): JSX.Element {
    const [updateUser,result]=useUpdateUserMutation();
    const {hasRole,userRole} = useAuth();
    const { register, handleSubmit,setError,watch, formState: { errors }  } = useForm({
        defaultValues:userParam,
        shouldUseNativeValidation: true,
        mode:'onBlur',
    });


    const rangacces=watch('rangacces');
    const {translate}=useTrads();
    useEffect(()=>{
        if(rangacces){
            const maxlevel=RoleLevel[userRole??roles.Visitors];
            if(RoleLevel[rangacces]>maxlevel){
                setError('rangacces',{type:'validate',message: translate('error_assign_higher_role')});
            }
        }
    },[rangacces,translate,userRole,setError])

    useEffect(()=>{
        if(result.error && 'data' in result.error) {
            const server_error:ResponseError=result.error as ResponseError;
            const errors =server_error.data.error;
            if(errors){
                for (const i in errors) {
                        setError(i, {type:'validate',message: translate(errors[i])});
                }
                result.reset();
            }
        }
    },[setError,result,translate]);
    const password=watch('password');
    const password_verif=watch('password_verif');
    
    return (
        result.isSuccess ? <Navigate to={`/user/${result.data.id.toString()}`} state={{modified:"true"}}></Navigate> :(
        result.error ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>:
        result.isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>:

        <form className="row" onSubmit={(event) =>void handleSubmit(updateUser)(event)}>
            <div className="col-12  mb-3">
                <FloatingInputBootStrap
                    name="identifiant"
                    label={translate('user_identifiant')}
                    type="text"
                    errors={errors}
                    registerOutput= {register("identifiant", {
                    required: translate("user_error_identifiant_requis"),
                    minLength: 2
                    })} 
                />
            </div>
            <div className="col-12  mb-3">
                <FloatingPrefixInputBootStrap
                    name="email"
                    label={translate('profil_email')}
                    type="email"
                    prefix="@"
                    errors={errors}
                    registerOutput= {register("email", {
                    required: translate("email_required"),
                    minLength: 2
                    })} 
                />
            </div>
            <div className="col-12  mb-3">

                <PasswordSetter
                    name="password"
                    label={translate('login_form_password')}
                    errors={errors}
                    registerOutput= {register("password", {
                    minLength: 2,
                    validate: (value) => {

                            if(password_verif && value !== password_verif){
                                return translate('password_verif_mismatch');
                            }
                            //return validatePassword(value);
                            return true;
                                    
                        }
                    })} 
                    registerOutputValidation= {
                        register("password_verif", {
                            minLength: 2,
                            validate: value => value === password || translate('password_verif_mismatch')
                    })} 
                    rest={{"autoComplete" : "new-password"}}
                    restValidation={{"autoComplete" : "new-password"}}
                />
            </div>








            {(hasRole(roles.Administrators) )?
                <>
                <div className="col-12  mb-3">
                    <FloatinBooleanBootstrap
                        name="validation"
                        label={translate('user_valide')}
                        type="text"
                        errors={errors}
                        registerOutput= {register("validation")} 
                    />
                </div>

                <div className="col-12  mb-3">
                    <FloatingInputBootStrap
                        name="apikey"
                        label={translate('user_apikey')}
                        type="text"
                        errors={errors}
                        registerOutput= {register("apikey")} 
                    />
                </div>
                </>

            :null}

            <div className="col-12  mb-3">
                <button type="submit">{translate('form_submit')}</button>
            </div>
        </form>
        )
    );
};

export default UserEditForm;